





































import Vue, { PropType } from 'vue';
import { SliderManager } from '@/components/Slider';

export default Vue.extend({
    components: { SliderManager: SliderManager as any },
    props: {
        images: Array as PropType<string[]>,
    },
    computed: {
        slides(): unknown[] {
            return (
                this.images?.reduce(
                    (acc, lg) => [...acc, { lg, size: 'contain' }],
                    [] as unknown[]
                ) || []
            );
        },
    },
});
